import React from "react";
import PropTypes from "prop-types";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./AddToBasketConfirmationModal.css";

export default class AddToBasketConfirmationModal extends React.Component {

  static propTypes = {
    type: PropTypes.oneOf([ "club", "payment" ]).isRequired,
    isOpen: PropTypes.bool,
    consentRequired: PropTypes.bool,
    limitedPlaces: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
      total: PropTypes.number,
      available: PropTypes.number,
      isPlaceReserved: PropTypes.bool
    }).isRequired
  }

  static defaultProps = {
    isOpen: true
  }

  onCancelClick = () => {
    this.props.onClose(false);
  }
  onOKClick = () => {
    this.props.onClose(true);
  }

  renderParentalConsentSection() {
    return (
      <React.Fragment>
        <div className="consent-and-limited-places-modal__title">Consent Required</div>
        <div className="consent-and-limited-places-modal__consent-message">Parental permission is required. Your consent will be granted when you check out.</div>
      </React.Fragment>
    )
  }

  renderLimitedPlacesSection() {
    const { limitedPlaces, type } = this.props;
    const isClub = type === "club";
    return (
      <React.Fragment>
        <div className="consent-and-limited-places-modal__title">Limited Places</div>
          <div className="consent-and-limited-places-modal__places">
            {
              isClub ?
              `${limitedPlaces.total} Places per Day` :
              `${limitedPlaces.available}\u00A0/\u00A0${limitedPlaces.total} Places Available`
            }
          </div>
        <div className="consent-and-limited-places-modal__places-message">Your place will be confirmed when you check out.</div>
      </React.Fragment>
    )
  }

  renderLimitedPlacesConfirmedSection() {
    return (
      <React.Fragment>
        <div className="consent-and-limited-places-modal__title">Limited Places</div>
        <div className="consent-and-limited-places-modal__places-message">Your place was already confirmed by an earlier payment. This payment will contribute towards paying off remaining amount.</div>
      </React.Fragment>
    )
  }

  render() {
    const { isOpen, consentRequired, limitedPlaces } = this.props;
    const hasLimitedPlaces = limitedPlaces.enabled && !limitedPlaces.isPlaceReserved;
    const isPlaceReserved = limitedPlaces.enabled && limitedPlaces.isPlaceReserved;
    
    return (
      <ModalDialog isOpen={isOpen}>
        <div className="consent-limited-places-modal">
          { consentRequired ? this.renderParentalConsentSection() : null }
          { hasLimitedPlaces ? this.renderLimitedPlacesSection() : null }
          { isPlaceReserved ? this.renderLimitedPlacesConfirmedSection() : null }
          <div className="consent-and-limited-places-modal__button-container">
            <Button className="consent-and-limited-places-modal__cancel-button" onClick={this.onCancelClick}>Cancel</Button>
            <Button className="consent-and-limited-places-modal__ok-button" onClick={this.onOKClick}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/school_money/AddToBasketConfirmationModal.js